import { JsonReader } from '../../imports/jsonReader';

const searchLoader = () => {
  const jsonFileContents = new JsonReader('./Assets/media/data/dataFile.json');
  const inputField = document.querySelector('#jsSearchInput') as HTMLInputElement;
  const inputButton = document.querySelector('#jsSearchButton');
  const itemHtmlStruct = document.querySelector('.js-search-item');
  const searchResults = document.querySelector('.js-search-results');
  const detailUrl = 'detail.html';
  const tagButtons = document.querySelectorAll('.js-tagButton');
  const tagResults = document.querySelectorAll('.js-tagButton-result');

  function searchItems(resultsField:any, itemfield:any, searchVal:string) {
    resultsField.innerHTML = '';

    if (searchVal != '' || searchVal != null) {
      jsonFileContents.searchByName(searchVal)
      .then( jsonData => {
        if ( jsonData.length > 0) {
          jsonData.forEach( (element:any) => {
            if ( itemfield ) {
              let itemLink = itemfield.querySelector('a');

              if (itemLink) {
                let hrefUrl = detailUrl + '?id=' + element.id + '&categ=' + element.familyname;
                itemLink.href = hrefUrl;
                if (element.displayname != '' && element.displayname != null) {
                  itemLink.innerHTML = element.displayname;
                } else if (element.searchalias != '' && element.searchalias != null) {
                  // if (element.searchalias.includes(searchVal)) {
                  //   itemLink.innerHTML = element.searchalias[element.searchalias.indexOf(searchVal)] + '(' + element.name + ')';
                  // } else {
                  //   itemLink.innerHTML = element.name;
                  // }
                  itemLink.innerHTML = element.searchalias[0] + '(' + element.name + ')';
                } else {
                  itemLink.innerHTML = element.name;
                }
              }

              let temp = itemfield.cloneNode(true);
              resultsField.appendChild(temp);
            }
          });
        } else {
          const noresult = document.createElement('li');
          noresult.classList.add('filter__link', 'filter__link--noresult');
          noresult.innerHTML = '検索結果がありませんでした。';
          resultsField.append(noresult);
        }

        //@ts-ignore
        new SimpleBar(searchResults, { autoHide: false } );
      })
      .catch(error => {
        console.error('Error:', error);
      });
    }
  }

  function replaceKanaHalfToFull(str:string) {
    var kanaMap = {
      'ｶﾞ': 'ガ', 'ｷﾞ': 'ギ', 'ｸﾞ': 'グ', 'ｹﾞ': 'ゲ', 'ｺﾞ': 'ゴ',
      'ｻﾞ': 'ザ', 'ｼﾞ': 'ジ', 'ｽﾞ': 'ズ', 'ｾﾞ': 'ゼ', 'ｿﾞ': 'ゾ',
      'ﾀﾞ': 'ダ', 'ﾁﾞ': 'ヂ', 'ﾂﾞ': 'ヅ', 'ﾃﾞ': 'デ', 'ﾄﾞ': 'ド',
      'ﾊﾞ': 'バ', 'ﾋﾞ': 'ビ', 'ﾌﾞ': 'ブ', 'ﾍﾞ': 'ベ', 'ﾎﾞ': 'ボ',
      'ﾊﾟ': 'パ', 'ﾋﾟ': 'ピ', 'ﾌﾟ': 'プ', 'ﾍﾟ': 'ペ', 'ﾎﾟ': 'ポ',
      'ｳﾞ': 'ヴ', 'ﾜﾞ': 'ヷ', 'ｦﾞ': 'ヺ',
      'ｱ': 'ア', 'ｲ': 'イ', 'ｳ': 'ウ', 'ｴ': 'エ', 'ｵ': 'オ',
      'ｶ': 'カ', 'ｷ': 'キ', 'ｸ': 'ク', 'ｹ': 'ケ', 'ｺ': 'コ',
      'ｻ': 'サ', 'ｼ': 'シ', 'ｽ': 'ス', 'ｾ': 'セ', 'ｿ': 'ソ',
      'ﾀ': 'タ', 'ﾁ': 'チ', 'ﾂ': 'ツ', 'ﾃ': 'テ', 'ﾄ': 'ト',
      'ﾅ': 'ナ', 'ﾆ': 'ニ', 'ﾇ': 'ヌ', 'ﾈ': 'ネ', 'ﾉ': 'ノ',
      'ﾊ': 'ハ', 'ﾋ': 'ヒ', 'ﾌ': 'フ', 'ﾍ': 'ヘ', 'ﾎ': 'ホ',
      'ﾏ': 'マ', 'ﾐ': 'ミ', 'ﾑ': 'ム', 'ﾒ': 'メ', 'ﾓ': 'モ',
      'ﾔ': 'ヤ', 'ﾕ': 'ユ', 'ﾖ': 'ヨ',
      'ﾗ': 'ラ', 'ﾘ': 'リ', 'ﾙ': 'ル', 'ﾚ': 'レ', 'ﾛ': 'ロ',
      'ﾜ': 'ワ', 'ｦ': 'ヲ', 'ﾝ': 'ン',
      'ｧ': 'ァ', 'ｨ': 'ィ', 'ｩ': 'ゥ', 'ｪ': 'ェ', 'ｫ': 'ォ',
      'ｯ': 'ッ', 'ｬ': 'ャ', 'ｭ': 'ュ', 'ｮ': 'ョ',
      '｡': '。', '､': '、', 'ｰ': 'ー', '｢': '「', '｣': '」', '･': '・'
    } as any;
    let reg = new RegExp('(' + Object.keys(kanaMap).join('|') + ')', 'g');
    return str.replace(reg, function (s) {
      return kanaMap[s];
    }).replace(/ﾞ/g, '゛').replace(/ﾟ/g, '゜');
  }

  if (inputField && jsonFileContents && searchResults && inputButton) {
    // var isComposing = false;

    // Composition Event Handlers
    // inputField.addEventListener('compositionstart', () => {
    //   isComposing = true;
    // });

    // inputField.addEventListener('compositionupdate', (event) => {
    //   // Handle intermediate composition updates
    //   // You can use event.data to access the current composition text
    //   if (isComposing) {
    //     // @ts-ignore
    //     let newvalue = replaceKanaHalfToFull(wanakana.toKatakana(event.data));
    //     searchItems(searchResults, itemHtmlStruct, (newvalue));
    //   }
    // });

    // inputField.addEventListener('compositionend', () => {
    //   isComposing = false;
    //   // Finalize the composition process, e.g., update the text field
    // });


    inputField.addEventListener('keyup', function (e) {
      // if (!isComposing) {
      //   // @ts-ignore
      //   let newvalue = replaceKanaHalfToFull(wanakana.toKatakana(inputField.value));
      //   searchItems(searchResults, itemHtmlStruct, (newvalue));
      // }
      if (e.key === 'Enter' || e.keyCode === 13) {
        // @ts-ignore
        let newvalue = replaceKanaHalfToFull(wanakana.toKatakana(inputField.value));
        searchItems(searchResults, itemHtmlStruct, (newvalue));
      }

      if (tagButtons.length > 0 && tagResults.length > 0) {
        tagButtons.forEach(element => {
          element.classList.remove('active');
          element.classList.remove('inactive');
        });
        tagResults.forEach(element => {
          element.classList.remove('active');
        });
      }
    });

    inputButton.addEventListener('click', function () {
      // @ts-ignore
      let newvalue = replaceKanaHalfToFull(wanakana.toKatakana(inputField.value));
      searchItems(searchResults, itemHtmlStruct, newvalue);

      if (tagButtons.length > 0 && tagResults.length > 0) {
        tagButtons.forEach(element => {
          element.classList.remove('active');
        });
        tagResults.forEach(element => {
          element.classList.remove('active');
        });
      }
    });
  }
};
  
export default searchLoader;